<template>
  <div
    class="login-bg"
    v-bind:style="{ backgroundImage: 'url(' + image + ')' }"
  >
    <v-main class="pt-4 mt-4">
      <v-container fluid fill-height grid-list-md>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 signup-card">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="headline text-center align-center">
                        <img
                          src="@/assets/img/volk-logo.png"
                          width="200"
                        ></img>
                      </div>
                      <!-- <p class="text-xs-center ">Professional Dyeing Services</p> -->
                    </div>

                    <br />
                    <v-form>
                      <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="Email"
                        type="email"
                        v-model="email"
                      ></v-text-field>
                      <v-text-field
                        prepend-icon="lock"
                        name="password"
                        label="Password"
                        id="password"
                        type="password"
                        v-model="password"
                      ></v-text-field>

                      <p class="text-xs-right">
                        <a @click="forgotPassword">Forgot your password?</a>
                      </p>
                      <v-btn @click="login" block dark color="#163758" large
                        >Sign In</v-btn
                      >
                      <br />
                      <p class="text-xs-center">
                        Not yet registered?
                        <a href="/signup">Sign Up</a>.
                      </p>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import image from "@/assets/nyc-bg.jpg";
import fb from "@/main";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      image,
    };
  },
  methods: {
    login: async function(e) {
      e.preventDefault();
      try {
        const userRes = await fb.auth.signInWithEmailAndPassword(
          this.email,
          this.password
        );
        const doc = await fb.db
          .collection("users")
          .doc(userRes.user.uid)
          .get();
        fb.analytics.logEvent("login", { ...doc.data() });
        this.$store.commit("cacheUser", doc.data());
        // Back to the page that sent them to login (e.g. an emailed link).
        // App paths only: "//host" and "/\host" would point off-site.
        const redirect = this.$route.query.redirect;
        this.$router.push(
          typeof redirect === "string" && /^\/(?![/\\])/.test(redirect)
            ? redirect
            : "/"
        );
      } catch (e) {
        alert(e);
      }
    },
    forgotPassword: function() {
      const email = prompt("Enter your email to request a password reset.");
      if (email) {
        fb.auth
          .sendPasswordResetEmail(email)
          .then(function() {
            alert("Email Sent with password reset link.");
          })
          .catch(function(error) {
            console.log("error sending password reset email.");
          });
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.signup-card {
  padding: 15px;
}
</style>
